/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import { ResponsiveHeroImage, LazyLoadImages } from "@quintype/components";
import { breakpoint } from "../../../../utils/breakpoint";
import { altTagOfHeroImages } from "../../../utils";

import "./hero-image.module.css";

export const HeroImage = ({ story = {}, desktopAspectRatio = [], mobileAspectRatio = [] }) => {
  const heroImage = story["hero-image-s3-key"];
  const [desktopWidth, desktopHeight] = desktopAspectRatio;

  if (!heroImage) {
    return <div styleName="fallback" />;
  }
  return (
    <figure styleName={`image size-${desktopWidth}x${desktopHeight}`}>
      <LazyLoadImages margin={"0px"}>
        {breakpoint("tablet") ? (
          <ResponsiveHeroImage
            story={story}
            aspectRatio={mobileAspectRatio}
            alt={altTagOfHeroImages(story)}
            defaultWidth={480}
            widths={[250, 480, 640]}
            sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 98%"
            imgParams={{ auto: ["format", "compress"], fit: "max" }}
          />
        ) : (
          <ResponsiveHeroImage
            story={story}
            aspectRatio={desktopAspectRatio}
            alt={altTagOfHeroImages(story)}
            defaultWidth={480}
            widths={[250, 480, 640, 960, 1200]}
            sizes="(max-width: 500px) 98%"
            imgParams={{ auto: ["format", "compress"], fit: "max" }}
          />
        )}
      </LazyLoadImages>
    </figure>
  );
};

HeroImage.propTypes = {
  story: PropTypes.object.isRequired,
  mobileAspectRatio: PropTypes.array,
  desktopAspectRatio: PropTypes.array
};
